const KEY = 'cast_device_id';

/** A random id persisted in localStorage — not true device fingerprinting, just a
 *  lightweight signal the payout engine's anti-gaming checks can use to spot the same
 *  browser/device being reused to game watch counts. Stable across sessions on one browser. */
export function getDeviceFingerprint() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = (crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}
